import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getCalculatorByKey } from "./registry";
import { CalculatorRenderer } from "./CalculatorRenderer";
import { ReckonerRenderer } from "./ReckonerRenderer";

export function CalculatorPage() {
  const { key } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const config = getCalculatorByKey(key);

  if (!config) {
    return (
      <div className="mx-auto max-w-5xl px-4 py-8">
        <p className="text-text">Calculator not found.</p>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="text-gold underline"
          data-testid="calc-page-back"
        >
          &larr; Go back
        </button>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="text-sm text-muted hover:text-gold"
        data-testid="calc-page-back"
      >
        &larr; Go back
      </button>
      <h1 className="mt-3 text-2xl font-semibold text-text">{config.title}</h1>
      <p className="mb-6 text-sm text-muted">{config.category}</p>
      {config.reckoner ? (
        <ReckonerRenderer config={config} />
      ) : (
        <CalculatorRenderer config={config} prefillInputs={location.state?.prefillInputs} />
      )}
    </div>
  );
}
